import {
  GetServerSidePropsContext,
  GetServerSidePropsResult,
  NextPage,
} from "next";
import { useEffect } from "react";

import PageHead from "~/components/common/PageHead";
import MobilePage from "~/components/item/page/[id]/MobilePage";
import PcPage from "~/components/item/page/[id]/PcPage";
import { Props } from "~/components/item/page/[id]/lib";
import useIsSpMode from "~/lib/client/hooks/useIsSpMode";
import { Layout } from "~/lib/client/layout";
import { useActivityLogger } from "~/lib/client/logger/useActivityLogger";
import { createGraphqlClient } from "~/lib/graphql/graphqlClient";

export async function getServerSideProps(
  context: GetServerSidePropsContext
): Promise<GetServerSidePropsResult<Props>> {
  const { id } = context.query;
  const client = createGraphqlClient();

  if (typeof id !== "string") {
    return {
      notFound: true,
    };
  }

  const { response } = await client.itemDetail({ id: parseInt(id) });

  return {
    props: {
      response,
    },
  };
}

const Page: NextPage<Props> = (props) => {
  const isSpMode = useIsSpMode();
  const sendActivityLog = useActivityLogger();

  useEffect(() => {
    if (!sendActivityLog) return;

    (async () => {
      await sendActivityLog({
        pageName: "itemDetail",
        actionName: "show",
      });
    })();
  }, [sendActivityLog]);

  return (
    <>
      <PageHead />
      <Layout layoutType={"YTLayout"}>
        {!isSpMode ? <PcPage {...props} /> : <MobilePage {...props} />}
      </Layout>
    </>
  );
};

export default Page;
